/** *
 * A super simple no dependency event bus to handler global events for forms
 * outside Vue to stop unessacy thrashing or binding to all components
 */

class FormEvent {
    constructor(name, ...payload) {
        this.name = name;
        this.payload = payload;
    }
}

class Listener {
    /**
     *
     * @param name
     * @param callback
     */
    constructor(name, callback) {
        this.name = name;
        this.callback = callback;
    }
}

class Bus {
    constructor() {
        /**
         * The event listeners as indeed list of arrays of call backs
         * @type {{}}
         */
        this.listeners = {};
    }

    /**
     * Register a listener
     * @param {Listener} listener
     */
    on(listener) {
        if (!this.listeners[listener.name]) {
            this.listeners[listener.name] = [];
        }
        this.listeners[listener.name].unshift(listener);
    }

    /**
     * Remove a listener
     *
     * @param {Listener} listener
     */
    off(listener) {
        const eventStack = this.listeners[listener.name];
        if (eventStack && eventStack.length) {
            eventStack.splice(eventStack.indexOf(listener), 1);
        }
    }

    /**
     * Fire an event
     *
     * @param {FormEvent} event
     * @return {[]} of results
     */
    trigger(event) {
        if (!this.listeners[event.name]) {
            return;
        }
        return this.listeners[event.name].reduce((runNext, listener) => runNext ? this._fire(event, listener) : runNext, true);
    }

    /**
     * Fire an event on a listener
     *
     * @param {FormEvent} event
     * @param {Listener} listener
     * @private
     */
    _fire(event, listener) {
        return listener.callback(...event.payload);
    }
}

export default {
    bus: new Bus(),
    on(eventName, callback) {
        const listener = new Listener(eventName, callback);
        this.bus.on(listener);
        return listener;
    },
    off(listener) {
        return this.bus.off(listener);
    },
    trigger(eventName, ...payload) {
        return this.bus.trigger(new FormEvent(eventName, ...payload));
    },
};



// WEBPACK FOOTER //
// ./src/components/form/validator/eventBus.js